export const util = {
    getCookie(key: string) {
        const encodedName = encodeURIComponent(key).replace(
            /[\-\.\+\*]/g,
            "\\$&"
        );
        const regex = new RegExp(
            "(?:(?:^|.*;)\\s*" + encodedName + "\\s*\\=\\s*([^;]*).*$)|^.*$"
        );

        return decodeURIComponent(document.cookie.replace(regex, "$1")) || null;
    }
};

export const fontFamily =
    "Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif";

/**
 * Get the Jira or Confluence application name from the path for TWCG-790 experiment
 * Not compatible for other applications.
 * @param path the path string, expected from window.location.pathname
 * @returns 'jira' or 'confluence', undefined if neither
 */
export const getAppFromPath = (
    path: string
): "jira" | "confluence" | undefined => {
    if (path === "") {
        return undefined;
    }

    // routes list from src/get-route.tsx and
    // src/templates/software/confluence/confluence-software-page/src/sections/confluence-navbar.tsx
    // software/confluence
    // software/confluence/pricing
    // software/confluence/free
    // software/confluence/templates
    // software/confluence/enterprise
    // software/confluence/resources
    if (path.startsWith("/software/confluence")) {
        return "confluence";
    }

    // routes list from src/get-route.tsx
    // software/jira
    // software/jira/features
    // software/jira/free
    // software/jira/pricing
    // software/jira/enterprise
    // software/jira/product-discovery
    // software/jira/product-discovery/pricing
    // software/jira/service-management
    // software/jira/service-management/product-pricing
    // software/jira/service-management/pricing
    // software/jira/service-management/enterprise
    // software/jira/templates/service-management
    if (path.startsWith("/software/jira")) {
        if (
            !path.includes("product-discovery") &&
            !path.includes("service-management")
        ) {
            return "jira";
        }
    }

    // from src/templates/software/jira/sections/nav-bar/software-jira-navbar.tsx
    if (path.startsWith("/jira/solutions")) {
        return "jira";
    }

    return undefined;
};
